function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFA000",
  d: "M41.456 34.385L23.778 16.707l-7.071 7.071L21.93 29H26v4h4v4h4v4h6.46l2.41-2.372z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFA000",
  d: "M8.929 8.929c-3.905 3.906-3.905 10.236 0 14.143 3.906 3.905 10.236 3.905 14.143 0 3.905-3.906 3.905-10.236 0-14.143-3.907-3.906-10.237-3.906-14.143 0zm6.192 6.192a3.001 3.001 0 01-4.243-4.243 3.001 3.001 0 014.243 4.243z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#D67C05"
}, React.createElement("path", {
  d: "M23.777 22.365l1.414-1.415L42.87 38.628l-1.414 1.414z"
}), React.createElement("path", {
  d: "M27.239 20.167l-1.586-1.585a9.947 9.947 0 01-7.071 7.071l1.591 1.59a11.953 11.953 0 004.313-2.758 11.915 11.915 0 002.753-4.318z"
}));

var Svg20ExitKey = function Svg20ExitKey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 344,
    height: 344,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg20ExitKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/20-exit-key.2d0ce6a6.svg";
export { ForwardRef as ReactComponent };